<template>
<div>
    <div class="overview">
      <h1>Indicatieve prijsopgave</h1>
        <table>
          <tr>
            <th>Blok</th>
            <th>Woningen</th>
            <th>Prijs</th>
            <th>Prijs per woning</th>
            <th>GBO</th>
            <th>GBO per woning</th>
            <th>€ / m&#178; GBO</th>
            <th>Inhoud</th>
            <th>Inhoud per woning</th>
            <th>€ / m&#179;</th>
            <th>Lengte blok</th>
            <th>TO</th>
            <th>Plattegrond</th>
          </tr>
          <tr v-for="(block, key) in $store.getters.fullConfig" :key="key" v-if="$store.getters.numberOfHouses(key) > 0">
          <!-- <tr v-for="(block, key) in $store.getters.fullConfig" :key="key"> -->
            <td>Blok {{ key }} ({{ block.verschijningsvorm }})</td>
            <td>{{ $store.getters.numberOfHouses(key) }}</td>
            <td class="align-right">€ {{ numberWithDots($store.getters.priceOfBlock(key)) }}</td>
            <td class="align-right">€ {{ numberWithDots($store.getters.average(key)) }}</td>
            <td class="align-right">{{ numberWithDots($store.getters.gbo(key)) }} m&#178;</td>
            <td class="align-right">{{ $store.getters.numberOfHouses(key) ? Math.round($store.getters.gbo(key) / $store.getters.numberOfHouses(key)) : 0 }} m&#178;</td>
            <td class="align-right">€ {{ numberWithDots(Math.round($store.getters.priceOfBlock(key) / $store.getters.gbo(key))) }}</td>
            <td class="align-right">{{ numberWithDots($store.getters.bi(key)) }} m&#179;</td>
            <td class="align-right">{{ $store.getters.numberOfHouses(key) ? Math.round($store.getters.bi(key) / $store.getters.numberOfHouses(key)) : 0 }} m&#179;</td>
            <td class="align-right">€ {{ numberWithDots(Math.round($store.getters.priceOfBlock(key) / $store.getters.bi(key))) }}</td>
            <td class="align-right">{{ $store.getters.totalLength(key) }} meter</td>
            <td class="align-right"><a href="static/TO.pdf" target="_blank">&#8615;</a></td>
            <td class="align-right"><a v-for="(value, maat, k) in $store.getters.pdfUrls(key)" :key="k" :href="value" target="_blank">{{ maat }}<br></a></td>
          </tr>
          <tr>
            <th>Totaal</th>
            <th>{{ $store.getters.total('numberOfHouses') }} <img src="static/img/fijn-warning.png" v-if="$store.getters.total('numberOfHouses') < 10" style="width:20px; margin-left: 10px;" title="Er zijn te weinig woningen geconfigureerd. (minimaal 10)"></th>
            <th class="align-right">€ {{ numberWithDots($store.getters.total('priceOfBlock')) }}</th>
            <th class="align-right">€ {{ $store.getters.total('numberOfHouses') ? numberWithDots(parseInt($store.getters.total('priceOfBlock') / $store.getters.total('numberOfHouses'))) : 0}}</th>
            <th class="align-right">{{ numberWithDots($store.getters.total('gbo')) }} m&#178;</th>
            <th class="align-right">{{ $store.getters.total('numberOfHouses') ? numberWithDots(parseInt($store.getters.total('gbo') / $store.getters.total('numberOfHouses'))) : 0}} m&#178;</th>
            <th class="align-right">€ {{ $store.getters.total('numberOfHouses') ? numberWithDots(parseInt($store.getters.total('priceOfBlock') / $store.getters.total('gbo'))) : 0 }}</th>
            <th class="align-right">{{ numberWithDots($store.getters.total('bi')) }} m&#179;</th>
            <th class="align-right">{{ $store.getters.total('numberOfHouses') ? numberWithDots(parseInt($store.getters.total('bi') / $store.getters.total('numberOfHouses'))) : 0}} m&#179;</th>
            <th class="align-right">€ {{ $store.getters.total('numberOfHouses') ? numberWithDots(parseInt($store.getters.total('priceOfBlock') / $store.getters.total('bi'))) : 0 }}</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </table>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { blockMixin } from '../mixins/block';

export default {
  mixins: [blockMixin],
  // props: ['blocks'],
  data: function() {
    return {
    };
  },
  computed : {
    ...mapGetters([
          'fullConfig',
        ]),
    // sortedBlocks() {
    //     return _.orderBy(this.blocks, 'id');
    // },
    blocks: function() { 
      return this.$store.getters.fullConfig;
    },
    totalItem: function(obj, tosum){
      let sum = 0;
      let key;
      for (key in obj) {
         var block = obj[key];
         console.log(block);
         sum += parseFloat(block[tosum]);
      }
      return sum;
    },
  },

  updated: function() {
    // console.log(this.sortedBlocks);
  },
}

</script>

<style>
div.overview {
   max-width: 1600px;
      /* max-height: 800px; */
      margin: auto;
      padding-top: 30px;
      /* position: absolute;
      top: 40%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%); */
}

.align-right {
  text-align: right;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  margin: 20px 0;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #F2DCDD;
}
</style>



// WEBPACK FOOTER //
// src/components/Overview.vue